import React, { useState } from "react";
import { Button, Col, Row, Modal } from "react-bootstrap";
import SVG from "react-inlinesvg";

import {
  delete_admin_template,
  get_admin_global_added_templates,
  add_new_choice_template_admin,
} from "../../../../../store/actions/SuperAdminActions/adminCreateCatalogue";
import { connect } from "react-redux";

import Alert from "react-s-alert";
import Media from "react-media";
import { AddButtonIconComponent } from "../../../../reusableComponents/buttonReusableComponent/ButtonReusableComponent";
const AddOnItem = (props) => {
  //state

  const [deleteTemplate, setDeleteTemplate] = useState(false);
  const [deleteItem, setDeleteItem] = useState(false);
  const [activeTemplateId, setActiveTemplateId] = useState("");
  const [activeItemId, setActiveItemId] = useState("");
  const [dataItem, setDataItem] = useState([]);

  const openDeleteTemplate = (id) => {
    setActiveTemplateId(id);
    setDeleteTemplate(true);
  };
  const openDeleteItem = (e, templateId, itemId, data) => {
    e.preventDefault();
    setActiveTemplateId(templateId);
    setActiveItemId(itemId);
    setDataItem(data);
    setDeleteItem(true);
  };
  const handleCloseDeleteTemplate = () => {
    setDeleteTemplate(false);
  };
  const handleCloseDeleteItem = () => {
    setDeleteItem(false);
  };

  const onSuccesDeleteCategory = () => {
    const token = props.auth.user.accessToken;

    props.get_admin_global_added_templates(token);
    Alert.success(`<h4> Deleted sucessfully</h4>`, {
      position: "top-right",
      effect: "bouncyflip",
      beep: true,
      html: true,
      timeout: 3000,
      offset: 35,
    });
    //props.onUpdateFormikDelete(activeTemplateId);
    setActiveTemplateId("");
    setActiveItemId("");
    setDataItem([]);
    handleCloseDeleteTemplate();
  };

  const onSuccesDeleteItem = () => {
    const token = props.auth.user.accessToken;

    props.get_admin_global_added_templates(token);
    Alert.success(`<h4> Deleted sucessfully</h4>`, {
      position: "top-right",
      effect: "bouncyflip",
      beep: true,
      html: true,
      timeout: 3000,
      offset: 35,
    });
    handleCloseDeleteItem();
    setActiveTemplateId("");
    setActiveItemId("");
    setDataItem([]);
    handleCloseDeleteTemplate();
  };

  const onClickDeleteTemplate = () => {
    const token = props.auth.user.accessToken;
    props.delete_admin_template(
      activeTemplateId,
      token,
      onSuccesDeleteCategory
    );
  };

  const onClickDeleteItem = () => {
    let formData = {};

    let filterData = dataItem.filter((item) => {
      return item._id !== activeItemId;
    });

    formData.options = filterData;
    const token = props.auth.user.accessToken;
    props.add_new_choice_template_admin(
      activeTemplateId,
      formData,
      token,
      onSuccesDeleteItem,
      "msg"
    );
  };

  //state
  const [showItems, setShowItems] = useState(false);
  const handleShowList = () => {
    setShowItems({
      showItems: !showItems.showItems,
    });
  };

  const onOpenEditModal = () => {};

  return (
    <React.Fragment>
      <div className="enCategoryListOnboarding rounded-0 enLightGRayHDR enGlobleCatelogueModalList p-0 mb-1">
        <Row className="align-items-center pr-4">
          <Col xs={5}>
            <div className="d-flex align-items-center">
              <div
                className="enCatelogueIconDiv cursor"
                onClick={handleShowList}
              >
                <SVG
                  width="27px"
                  src={
                    showItems.showItems
                      ? require("../../../../../assets/images/UserManagement/minus-black-o.svg")
                      : require("../../../../../assets/images/UserManagement/plus-black-o.svg")
                  }
                />
              </div>
              <div className="f12-500 pl-3">{props.data.name}</div>
            </div>
          </Col>
          <Col
            xs={7}
            className="d-flex flex-wrap align-items-center justify-content-end"
          >
            <Button
              variant="outline-secondary"
              className="btn-sm mr-2"
              onClick={() => props.onClick(props.data._id)}
            >
              Add Options
            </Button>
            <button
              type="button"
              className="enBtnoutlineBlueIcon mr-2"
              onClick={() => props.onEditChoice(props.data._id, props.data)}
              //onClick={(e) => onOpenEditModal(props.data._id)}
            >
              <SVG
                src={require("../../../../../assets/images/UserManagement/pencil.svg")}
              />
            </button>
            {/* <DeleteModal name="Category" /> */}

            <button
              type="button"
              className="enBtnoutlineBlueIcon mr-2"
              onClick={(e) => openDeleteTemplate(props.data._id)}
            >
              <SVG
                src={require("../../../../../assets/images/UserManagement/Delete.svg")}
              />
            </button>
          </Col>
        </Row>
      </div>
      {showItems.showItems && (
        <React.Fragment>
          {props.data.options.map((item, index) => (
            <div className="enSubCategory top-border-merge" key={index}>
              <Row className="align-items-center py-2">
                <Col xs={6}>
                  <div className="d-flex align-items-center">
                    <SVG
                      width="16px"
                      height="16px"
                      src={
                        item.veg
                          ? require("../../../../../assets/images/UserManagement/veg.svg")
                          : require("../../../../../assets/images/UserManagement/nonveg.svg")
                      }
                    />
                    <div className="f12-500 mobile-f12-400 pl-2">
                      {item.name}
                    </div>
                  </div>
                </Col>
                <Col xs={2} md={3} className="pl-0">
                  <div className="f12-500 mobile-f12-400">
                    <span className="text-red mr-1">₹</span>
                    {item.price}
                  </div>
                </Col>
                <Col xs={4} md={3} className="pl-0">
                  <div className="d-flex">
                    <button
                      className="editIcon-blue"
                      type="button"
                      onClick={() =>
                        props.onClick(props.data._id, item._id, item)
                      }
                    >
                      <SVG
                        src={require("../../../../../assets/images/UserManagement/pencil.svg")}
                      />
                    </button>
                    <Media query="(min-width: 992px)">
                      <div className="enRemoveBtn">
                        <AddButtonIconComponent
                          buttonText="Remove"
                          fontIcon="fa fa-trash"
                          colorCss="red"
                          onClick={(e) =>
                            openDeleteItem(
                              e,
                              props.data._id,
                              item._id,
                              props.data.options
                            )
                          }
                        />
                      </div>
                    </Media>
                    <Media query="(max-width: 991px)">
                      <div className="enRemoveBtn">
                        <AddButtonIconComponent
                          fontIcon="fa fa-trash"
                          colorCss="red"
                          onClick={(e) =>
                            openDeleteItem(
                              e,
                              props.data._id,
                              item._id,
                              props.data.options
                            )
                          }
                        />
                      </div>
                    </Media>
                  </div>
                </Col>
              </Row>
            </div>
          ))}
        </React.Fragment>
      )}
      <Modal show={deleteTemplate} onHide={handleCloseDeleteTemplate} centered>
        <Modal.Header className="py-0 pt-2 border-0" closeButton>
          <Modal.Title></Modal.Title>
        </Modal.Header>
        <Modal.Body className="f16-500">
          Are you sure to Delete this template ?
        </Modal.Body>
        <Modal.Footer className="justify-content-start border-0">
          <Button
            variant="outline-secondary"
            className="btn-lg mr-4 px-5"
            onClick={handleCloseDeleteTemplate}
          >
            No
          </Button>
          <Button
            variant="danger"
            className="btn-lg px-5"
            onClick={() => onClickDeleteTemplate()}
          >
            Yes
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={deleteItem} onHide={handleCloseDeleteItem} centered>
        <Modal.Header className="py-0 pt-2 border-0" closeButton>
          <Modal.Title></Modal.Title>
        </Modal.Header>
        <Modal.Body className="f16-500">
          Are you sure to Delete this item ?
        </Modal.Body>
        <Modal.Footer className="justify-content-start border-0">
          <Button
            variant="outline-secondary"
            className="btn-lg mr-4 px-5"
            onClick={handleCloseDeleteItem}
          >
            No
          </Button>
          <Button
            variant="danger"
            className="btn-lg px-5"
            onClick={() => onClickDeleteItem()}
          >
            Yes
          </Button>
        </Modal.Footer>
      </Modal>
    </React.Fragment>
  );
};

AddOnItem.propTypes = {};

const mapStateToProps = (state) => ({
  auth: state.auth,
  templates: state.commonSuperAdmin.admin_global_templates,
});

export default connect(mapStateToProps, {
  get_admin_global_added_templates,
  delete_admin_template,
  add_new_choice_template_admin,
})(AddOnItem);
